import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/images/left.png';
import _imports_1 from '../../../assets/images/right.png';

const _withScopeId = n => (_pushScopeId("data-v-764123a2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "teacher-main-wrapper"
};
const _hoisted_2 = {
  key: 0,
  class: "swiper-box"
};

const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"custom-nav\" data-v-764123a2><button class=\"custom-prev3\" data-v-764123a2><img src=\"" + _imports_0 + "\" alt=\"\" data-v-764123a2></button><button class=\"custom-next3\" data-v-764123a2><img src=\"" + _imports_1 + "\" alt=\"\" data-v-764123a2></button></div>", 1);

const _hoisted_4 = {
  key: 2,
  class: "more"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202508/b3d981c05f614b0bb06d2d806ff4f3f7.png"
}, null, -1));

const _hoisted_7 = [_hoisted_5, _hoisted_6];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CommonTitle = _resolveComponent("CommonTitle");

  const _component_TeacherCard = _resolveComponent("TeacherCard");

  const _component_SwiperSlide = _resolveComponent("SwiperSlide");

  const _component_Swiper = _resolveComponent("Swiper");

  const _component_Empty = _resolveComponent("Empty");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_CommonTitle, {
    flag: false
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($props.menu && $props.menu.module_name || '教学名师'), 1)]),
    _: 1
  }), $data.teacherList && $data.teacherList.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_Swiper, {
    watchSlidesProgress: true,
    slidesPerView: 4,
    spaceBetween: 24,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    modules: $data.modules,
    loop: true,
    navigation: {
      nextEl: '.custom-next3',
      prevEl: '.custom-prev3'
    },
    onSlideChange: $options.handleSlideChange,
    class: "course-list swiper-content"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.teacherList, (value, index) => {
      return _openBlock(), _createBlock(_component_SwiperSlide, {
        class: "swiper-slide",
        id: value.id,
        key: value.id
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_component_TeacherCard, {
          key: value.id,
          teacherData: value,
          menu: $props.menu,
          style: _normalizeStyle({
            '--delay': `${index * 0.1}s`
          }),
          class: _normalizeClass(["animated-card", {
            'active': $data.currentIndex === index
          }]),
          onMouseenter: $event => $data.currentIndex = index
        }, null, 8, ["teacherData", "menu", "style", "onMouseenter", "class"]))]),
        _: 2
      }, 1032, ["id"]);
    }), 128))]),
    _: 1
  }, 8, ["modules", "navigation", "onSlideChange"]), _hoisted_3])) : (_openBlock(), _createBlock(_component_Empty, {
    key: 1,
    style: {
      "margin-top": "40px"
    },
    type: "people"
  })), $data.teacherList && $data.teacherList.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("a", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleMore && $options.handleMore(...args))
  }, _hoisted_7)])) : _createCommentVNode("", true)]);
}